module.exports = __webpack_public_path__ + "img/ningweixi.f98ad513.jpg";